export default {
  name: 'partner-logo',
  data() {
    return {
      logoList: ['zszq.png', 'swzq.png', 'dfzq.png', 'cjzq.png', 'pazq.png', 'ytzq.png', 'dwzq.png', 'zgyhzq.png', 'hentzq.png', 'wlzq.png', 'cdzq.png', 'htzq.png', 'zyzq.png', 'xyzq.png', 'ctzq.png']
    };
  }
};